var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { margin, compose } from 'styled-system';
import { Link as RouterLink, } from 'react-router-dom';
import { IconWithText } from '../shared/IconWithText';
import { buttonVariants, stylesBySize, useAction } from '../shared';
import { isExternalURI } from '../../tools/utils/isExternalURI';
const composedStyledSystemProps = compose(margin, buttonVariants);
const styledAnchorConfig = {
    /**
     * This is necessary because styled components will not pass
     * non-standard attributes to DOM elements if `styled` is wrapping
     * a native DOM element. However, if a custom component is wrapped
     * by `styled`, then all attributes/props will be passed. See
     * https://styled-components.com/docs/basics#passed-props
     */
    shouldForwardProp: (prop, defaultValidatorFn) => {
        return prop === 'allytmln' || defaultValidatorFn(prop);
    },
};
const linkStyles = css(props => {
    const { variant, $isUnderlined, $width } = props;
    return css `
    ${composedStyledSystemProps}
    ${$isUnderlined ? 'text-decoration: underline;' : ''}
    ${variant === 'link'
        ? `white-space: normal; 
          display: inline;`
        : ''}
    ${variant !== 'link' && props.size ? stylesBySize[props.size] : css ``};
    box-sizing: border-box;
    width: ${$width};
  `;
});
const StyledAnchor = styled.a.withConfig(styledAnchorConfig) `
  ${linkStyles}
`;
const StyledRouterLink = styled(RouterLink) `
  ${linkStyles}
`;
const Link = React.forwardRef((_a, ref) => {
    var { to = '', text, className = '', onClick, target, isUnderlined = false, id, icon, withAllyTM = true, disableFullWidthSmDown, fullWidthMd, unsupportedContent } = _a, props = __rest(_a, ["to", "text", "className", "onClick", "target", "isUnderlined", "id", "icon", "withAllyTM", "disableFullWidthSmDown", "fullWidthMd", "unsupportedContent"]);
    const isExternal = (typeof to === 'string' && isExternalURI(to)) || !!props.download;
    const { safeId, allyTM, derivedSize, width, iconFill, theme } = useAction('button', id, withAllyTM, disableFullWidthSmDown, fullWidthMd, props.variant, text, 'size' in props ? props.size : undefined);
    const baseProps = Object.assign({ className,
        onClick,
        ref, $isUnderlined: isUnderlined, id: safeId, $width: width, rel: 'noreferrer noopener', target }, allyTM);
    return isExternal ? (React.createElement(StyledAnchor, Object.assign({}, baseProps, { href: to }, (props.variant !== 'link' ? { size: derivedSize } : {}), props),
        React.createElement(IconWithText, Object.assign({ icon: icon, iconFill: iconFill, theme: theme }, (props.variant !== 'link' ? { size: derivedSize } : {})), text || unsupportedContent))) : (React.createElement(StyledRouterLink, Object.assign({}, baseProps, { to: to }, (props.variant !== 'link' ? { size: derivedSize } : {}), props),
        React.createElement(IconWithText, Object.assign({ icon: icon, iconFill: iconFill, theme: theme }, (props.variant !== 'link' ? { size: derivedSize } : {})), text || unsupportedContent)));
});
Link.defaultProps = {
    variant: 'link',
};
export { Link };
//# sourceMappingURL=Link.js.map